import { Component } from '@angular/core';
import { SignalsProvider } from '../../providers/signals/signals';
import { LiveSignal } from '../../models/Signal';

/**
 * Generated class for the SignalsCalendarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'signals-calendar',
  templateUrl: 'signals-calendar.html'
})
export class SignalsCalendarComponent {

  text: string;
  events = [];
  selectedEvents = [];
  constructor(public signalsCtrl: SignalsProvider) {
    this.text = 'Hello World';
    this.setEvents();
  }

  setEvents(){
    let events = [];
    this.signalsCtrl.allSignals.first().subscribe(signals => {
      for(let signal of signals){
        let date = new Date(parseInt(signal.data.timestamp));
        let event = {
          year: date.getFullYear(),
          month: date.getMonth(),
          date: date.getDate(),
          signal: signal
        }
        events.push(event);
      }
      this.events = events;
    })
  }

  onDaySelect(event){
    console.log(event);
    this.selectedEvents = this.getEventsByDate(event.year, event.month, event.date);

    console.log(this.selectedEvents);
  }
  onMonthSelect(event){
    console.log(event);
  }

  getEventsByDate(year, month, date){
    console.log(arguments);
    return this.events.filter(event => {
      return event.year == year && event.month == month && event.date == date;
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/signals-calendar/signals-calendar.ts